import { format } from "date-fns";
import { compactPreviewText } from "@/lib/feed/rich-content";

type DateLike = Date | string | number | null | undefined;

const parseDateLike = (value: DateLike) => {
  if (value == null) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatFeedDateTime = (value: DateLike) => {
  const date = parseDateLike(value);
  return date ? format(date, "MMM d, h:mm a") : null;
};

const possessiveLabel = (displayName: string) => {
  const trimmed = displayName.trim();
  if (!trimmed) return "Your";
  return trimmed.endsWith("s") ? `${trimmed}'` : `${trimmed}'s`;
};

export function buildGeneratedSessionTitle({
  activityName,
  displayName,
  startAt,
  startDate,
  startTime,
}: {
  activityName: string | null | undefined;
  displayName: string | null | undefined;
  startAt?: DateLike;
  startDate?: string | null;
  startTime?: string | null;
}) {
  const activityLabel = activityName?.trim() || "Activity";
  const ownerLabel = possessiveLabel(displayName?.trim() || "Your");
  const composedStart =
    startAt ?? (startDate && startTime ? `${startDate}T${startTime}` : null);
  const timeLabel = formatFeedDateTime(composedStart);

  return [
    `${ownerLabel} ${activityLabel} Session`,
    timeLabel ? `- ${timeLabel}` : null,
  ]
    .filter(Boolean)
    .join(" ");
}

export function buildPostShareTitle({
  authorName,
  kind,
}: {
  authorName: string | null | undefined;
  kind?: string | null;
}) {
  const label = kind === "poll" ? "Poll" : "Post";
  const authorLabel = authorName?.trim();
  return authorLabel ? `${label} by ${authorLabel}` : label;
}

export function buildPostShareSubtitle({
  content,
  locationName,
  hasMedia,
}: {
  content: string | null | undefined;
  locationName?: string | null;
  hasMedia?: boolean;
}) {
  return (
    compactPreviewText(content) ??
    locationName?.trim() ??
    (hasMedia ? "Media post" : null)
  );
}
